export default "__VITE_ASSET__BnvTq2kT__"